const pickChangedFields = require ('./pickChangedFields');
const _ = require('lodash');

module.exports = (angularModule) => {

  angularModule.directive('adviceLocalApiKey', () => {
    return {
      restrict: 'E',
      template: `
      <input
            class="form-control" type="text"
            ng-blur="validateAdviceLocalApiKey()"
            ng-disabled="ngDisabled"
            ng-model="ngModel" />
        <span class="fas fa-spinner fa-spin" ng-show="loadingAdviceLocalApiKeyValidity"></span>
        <span ng-show="!loadingAdviceLocalApiKeyValidity && isApiKeyValid !== undefined">
            <span ng-if="isApiKeyValid" class="text-success">
                <span class="fas fa-check text-success"></span> API key is valid
            </span>
            <span ng-if="!isApiKeyValid" class="text-danger">
                <span class="far fa-times text-danger"></span> API key is not valid!
            </span>

        </span>
`,
      scope: {
        ngDisabled: '=',
        ngModel: '='
      },
      controller: ($scope, configService) => {
        $scope.isApiKeyValid = undefined;
        $scope.loadingAdviceLocalApiKeyValidity = false;
        $scope.validateAdviceLocalApiKey = () => {
          const key = $scope.ngModel;

          if (!key) {
            $scope.isApiKeyValid = undefined
          } else {
            $scope.loadingAdviceLocalApiKeyValidity = true;

            configService.isAdviceLocalApiKeyValid(key).then(
              result => {
                $scope.loadingAdviceLocalApiKeyValidity = false;
                $scope.isApiKeyValid = result.data;
              })
          }
        }
      }
    }
  });

  angularModule.directive('servicesConfigEditor', () => {
    return {
      restrict: 'E',
      template: require('./servicesConfigEditor.html'),
      scope: {
        model: '='
      },
      controller: ($scope) => {
        $scope.setDefaultForServiceLevel = () => {
          const reportsServiceLevel = $scope.model && $scope.model.account.services.reportsService.level;
          let reportsAllowed;
          let componentsAllowed;
          switch (reportsServiceLevel) {
            case "basic":
              reportsAllowed = 3;
              componentsAllowed = 4;
              break;
            case "plus":
              reportsAllowed = 10;
              componentsAllowed = 10;
              break;
            case "premium":
            default: // unlimited.
              reportsAllowed = 0;
              componentsAllowed = 0;
          }

          $scope.model.account.services.reportsService.reportsAllowed = reportsAllowed;
          $scope.model.account.services.reportsService.componentsAllowed = componentsAllowed;
        }; // end setDefaultForServiceLevel


      }
    }
  })
};

module.exports.fromConfigAndAccount = (config, account) => {
  return {
    account,
    featureRestrictions: {
      hideListingManagementAccuracyReport: !config.brandConfig.restrictions.hideListingManagementAccuracyReport
    },
    accountConfig: {
      devHubConfig: {
        apiEndpoint: config.accountConfig.devHubConfig.apiEndpoint,
      },
      adviceLocalConfig: {
        unitedStatesApiKey: config.accountConfig.adviceLocalConfig.unitedStatesApiKey,
        canadaApiKey: config.accountConfig.adviceLocalConfig.canadaApiKey
      },
      serviceDefaults: config.accountConfig.serviceDefaults
    }
  }
}

module.exports.toConfig = (config) => {
  return config
}

module.exports.toAccount = ({ account }) => {
  return account
}

module.exports.sparsify = (before, after) => {
  return {
    accountConfig: {
      adviceLocalConfig: pickChangedFields(before.accountConfig.adviceLocalConfig, after.accountConfig.adviceLocalConfig),
      devHubConfig: pickChangedFields(before.accountConfig.devHubConfig, after.accountConfig.devHubConfig),
      serviceDefaults: pickChangedFields(before.accountConfig.serviceDefaults, after.accountConfig.serviceDefaults)
    },
    brandConfig: {
      restrictions: _.reduce(
        pickChangedFields(before.featureRestrictions, after.featureRestrictions),
        (x, val, key) => _.set(x, key, !val),
        {}
      )
    }
  }

}
